import Cookies from 'js-cookie';
import { isEmpty, isNil } from 'lodash';

import { USER_CL_EVENTS_KEY, CL_EVENTS_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchEventCode({ dispatch }, eventId) {
  return http.get(`${CL_EVENTS_API_URL}/events/${eventId}/event-codes`)
    .then(res => (
      dispatch('updateClEvent', { eventName: eventId, value: res.data })
    ))
    .catch((err) => {
      const res = err.response;

      if (res && res.status === 404) {
        return dispatch('updateClEvent', { eventName: eventId, value: false });
      }

      // TODO: handle error
      console.error('err while fetching event code:', err);
      return Promise.reject(err);
    });
}

export function createEventCode({ dispatch }, { eventId, coinAmount }) {
  return http.post(`${CL_EVENTS_API_URL}/events/${eventId}/event-codes`, { coin_amount: coinAmount })
    .then(res => (
      dispatch('updateClEvent', { eventName: eventId, value: res.data })
    ))
    .catch((err) => {
      const res = err.response;

      if (res && res.status === 409) {
        console.error(res.data.error_description);
        return true;
      }

      // TODO: handle error
      console.error('err while creating event code:', err);
      return Promise.reject(err);
    });
}

export function checkUserClEvents({ dispatch, state, getters }, eventId) {
  if (!isEmpty(state.clEvents)) {
    return Promise.resolve(state.clEvents);
  }

  const userClEventsStr = Cookies.get(`${USER_CL_EVENTS_KEY}/${getters.currentUserId}`);

  if (isEmpty(userClEventsStr)) {
    return dispatch('fetchEventCode', eventId);
  }

  const userClEvents = JSON.parse(userClEventsStr);

  if (isNil(userClEvents[eventId])) {
    return dispatch('fetchEventCode', eventId);
  }

  if (!userClEvents[eventId].is_expired) {
    return dispatch('fetchEventCode', eventId);
  }

  return dispatch('setClEvents', userClEvents);
}

export function setClEvents({ commit }, clEvents) {
  commit(types.SET_CL_EVENTS, clEvents);

  return Promise.resolve();
}

export function updateClEvent({ commit }, { eventName, value }) {
  commit(types.UPDATE_CL_EVENT, { eventName, value });

  return Promise.resolve();
}



// WEBPACK FOOTER //
// ./src/app/cl-events/store/actions.js